<template>
    <div class='d-flex justify-space-between align-center w-100'>
        <v-avatar :size='size' color='primary ml-2'>
            <v-img
                    v-if='user.photo && !userImageLoadError' :alt='user.name'
                    :src='store.public_url+ "/"+ user.photo'
                    @error='imageLoadError'
            >
                <template v-slot:placeholder>
                    <v-row
                            class='fill-height ma-0'
                            align='center'
                            justify='center'
                    >
                        <v-progress-circular
                                indeterminate
                                color='grey lighten-5'
                        ></v-progress-circular>
                    </v-row>
                </template>
            </v-img>
            <span
                    class='white--text caption'
                    v-else
            >
				{{ user.name ? user.name.substr(0, 2).toUpperCase() : '' }}
			</span>
        </v-avatar>
        <div class='flex-grow-1'>
            <router-link
                    :is="!isLink || user._id === store.user._id ? 'span' : 'router-link'"
                    :to="{name:'UserProfile',query:{user_id:user._id}}"
                    class='name text-decoration-none'
            >
                <small v-if='small'>{{ user.name }}</small>
                <span v-else>{{ user.name }}</span>
            </router-link>
            <div v-if='showPhone'>
                <small v-if='small'>{{ user.phone }}</small>
                <span v-else>{{ user.phone }}</span>
            </div>
            <div v-if='!noStatus'>
                <div v-if='status'>
                    <v-chip x-small :color='store.statusColor.user[status]'>
                        {{ store.translate.fa.user.status[status] }}
                    </v-chip>
                </div>
                <div v-else class='status'>
                    <v-chip x-small v-if='user.status' :color='store.statusColor.user[user.status]'>
                        {{ store.translate.fa.user.status[user.status] }}
                    </v-chip>
                </div>
            </div>

        </div>
        <v-spacer/>
        <div>
            <v-menu
                    v-if='user._id !== store.user._id && !noMenu'
                    offset-y
                    bottom
                    right
            >
                <template v-slot:activator='{ on, attrs }'>
                    <v-btn
                            icon
                            v-bind='attrs'
                            v-on='on'
                    >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <slot>
                    <v-list>
                        <v-list-item
                                :to='{name:"NewMessage",params:{user_id:user._id}}'>
                            <v-list-item-title>ارسال پیام</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                :to="{name:'UserProfile',query:{user_id:user._id}}">
                            <v-list-item-title>مشاهده پروفایل</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </slot>

            </v-menu>
            <slot name='sendMessage'></slot>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'User',
        data: () => ({
            userImageLoadError: false
        }),
        props: {
            noStatus: Boolean,
            showPhone: Boolean,
            noMenu: Boolean,

            isLink: {
                type: Boolean,
                default: false
            },

            small: Boolean,

            user: Object,
            status: String,
            size: {
                type: [Number, String],
                default: 48
            }
        },
        methods: {
            imageLoadError() {
                this.userImageLoadError = true;
            }
        },
        computed: {
            ...mapState({store: state => state})
        },
        mounted() {
        }
    };
</script>

<style scoped lang='scss'>
    .v-card {
        box-shadow: none !important;
        padding: 4px;
    }
</style>
